module.exports = __webpack_public_path__ + "static/media/doc.d633b047.svg";